module.exports = __webpack_public_path__ + "static/media/ux.e682483a.svg";